<template>
    <div class="school-settings">
        <p class="card-description">{{ $t('school.the_settings_below_apply_to_the_entire_school') }}</p>

        <div class="row">
            <div class="col-12 col-md-8 col-xl-6">
                <div class="school-setting">
                    <design-2021-apprentice-data-table
                        nosearch
                        :fields="fields"
                        :items="items"
                        :custom-per-page="25">
                        <template #cell(actions)="data">
                            <div
                                class="settings-toggle"
                                v-if="data.item.option !== 'Favoriete Editor'">
                                <b-form-checkbox
                                    v-model="data.item.actions"
                                    :id="`settings-toggler-${data.item.options}`"
                                    :value="true"
                                    size="5"
                                    :unchecked-value="false"
                                    :disabled="data.item.disabled"
                                    switch>
                                </b-form-checkbox>
                            </div>
                            <div v-else>
                                <b-form-select
                                    v-model="data.item.actions"
                                    :options="types">
                                </b-form-select>
                            </div>
                        </template>
                    </design-2021-apprentice-data-table>

                    <b-button
                        class="btn-save btn-save-settings"
                        variant="primary"
                        @click="save()">
                        {{ $t('common.save') }}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-school-settings-settings-component',
    props: ['settingsIn', 'disabledIn', 'googleDriveIn', 'sharepointIn'],
    data() {
        return {
            fields: [
                {
                    key: 'options',
                    label: this.$t('school.options'),
                },

                {
                    key: 'actions',
                    label: 'Status',
                },
            ],
            types: [
                { value: null, text: this.$t('school.choose_an_editor_type') },
                { value: 'oo', text: 'Only Office' },
                { value: 'moo', text: 'Microsoft Office Online' },
                { value: 'sp', text: 'Office 365' },
                { value: 'gd', text: 'Google Docs' },
            ],
            items: [
                {
                    options: 'Google Docs',
                    actions: this.googleDriveIn === null,
                    disabled: true,
                },
                {
                    options: 'Sharepoint (Office 365)',
                    actions: this.sharepointIn === null,
                    disabled: true,
                },
                {
                    options: 'App (Via Socie)',
                    actions: this.settingsIn?.app ?? false,
                    disabled: false,
                },
                {
                    options: 'Britannica',
                    actions: this.settingsIn?.britannica ?? false,
                    disabled: false,
                },
                {
                    options: 'Digistudies',
                    actions: this.settingsIn?.digistudies ?? false,
                    disabled: false,
                },
                {
                    options: 'Modules',
                    actions: this.settingsIn?.modules ?? false,
                    disabled: false,
                },
                {
                    options: this.$t('school.profile_choice'),
                    actions: this.settingsIn?.profile_choice ?? false,
                    disabled: false,
                },
                {
                    options: this.$t('school.questionnaire'),
                    actions: this.settingsIn?.custom_forms ?? false,
                    disabled: true,
                },
                {
                    options: this.$t('school.new_learning_way'),
                    actions: this.settingsIn?.learning_path ?? false,
                    disabled: false,
                },
                {
                    options: this.$t('school.organizations'),
                    actions: this.settingsIn?.organizations ?? false,
                    disabled: false,
                },
                {
                    options: 'SLU dashboard',
                    actions: this.settingsIn?.slu_dashboard ?? false,
                },
                {
                    options: 'Stages',
                    actions: this.settingsIn?.internships ?? false,
                    disabled: false,
                },
                {
                    options: this.$t('school.favorite_editor'),
                    actions: this.settingsIn?.editor_type ?? null,
                    disabled: false,
                },
            ],
        };
    },
    methods: {
        save() {
            let data = {
                app: this.items[2].actions,
                britannica: this.items[3].actions,
                digistudies: this.items[4].actions,
                modules: this.items[5].actions,
                profile_choice: this.items[6].actions,
                custom_forms: this.items[7].actions,
                learning_path: this.items[8].actions,
                organizations: this.items[9].actions,
                slu_dashboard: this.items[10].actions,
                internships: this.items[11].actions,
                editor_type: this.items[12].actions,
            };

            this.alert.saving();

            this.axios.post(this.routes.schoolSettingsUpdate(), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.school-settings {
    .description {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .btn-save-settings {
        margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    }
}
</style>
